module.exports = __webpack_public_path__ + "static/img/xi_1.ecbb55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_1.png
// module id = BFh2
// module chunks = 1